// @flow
import React, { PureComponent } from "react"
import Cookies from "js-cookie"
import { connect } from "react-redux"

import { getScrollingElement } from "common/utils/scrollUtils"
import { throttleTrailing } from "common/utils/fpThrottleWithOptions"
import MobileAdComponent from "./MobileAdComponent"
import translate from "../../../../app/scripts/tools/translate"
import cuckoo from "../../services/cuckoo/cuckoo"
import { setOption } from "../../services/options/actions"

const isiOS =
  typeof window !== "undefined" ? /(iPhone|iPad|iPod)/i.test(window.navigator.userAgent) : false
const isIphone =
  typeof window !== "undefined" ? /(iPhone)/i.test(window.navigator.userAgent) : false
const isAndroid = typeof window !== "undefined" ? /Android/.test(window.navigator.userAgent) : false

type Props = {
  showMobileAd: boolean,
  setOption: (string, boolean) => { type: string, option: string, value: boolean },
}

type State = {
  hidden: boolean,
}

class MobileAd extends PureComponent<Props, State> {
  state = {
    hidden: false,
  }

  componentDidMount() {
    if (
      (isAndroid || isiOS) &&
      !Cookies.get("ignore_mobile_ad") &&
      !Cookies.get("SKYPICKER_AFFILIATE")
    ) {
      this.props.setOption("showMobileAd", true)
    }

    window.addEventListener("scroll", this.handleScroll)

    this.handleScroll()
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  onClose = () => {
    this.props.setOption("showMobileAd", false)
    Cookies.set("ignore_mobile_ad", "true", window.Skypicker.cookieOptions)
  }

  handleScroll = throttleTrailing(100, () => {
    const { showMobileAd } = this.props

    if (!showMobileAd) {
      return
    }

    const scrollEl = getScrollingElement()

    if (!scrollEl) {
      return
    }

    const { hidden } = this.state

    const treshold = 100
    const isBottom = scrollEl.scrollHeight - scrollEl.clientHeight - scrollEl.scrollTop <= treshold

    if (isBottom) {
      if (!hidden) {
        this.setState({ hidden: true })
      }
    } else if (hidden) {
      this.setState({ hidden: false })
    }
  })

  trackAndroid = () => {
    cuckoo.infinario("trackAppDownload", {
      action: "buttonClick",
      type: "android",
      context: "mobileAdBanner",
    })
  }

  trackiOS = () => {
    cuckoo.infinario("trackAppDownload", {
      action: "buttonClick",
      type: isIphone ? "iPhone" : "iPad",
      context: "mobileAdBanner",
    })
  }

  render() {
    if (this.state.hidden) {
      return null
    }
    if (this.props.showMobileAd && isAndroid) {
      return (
        <MobileAdComponent
          onClose={this.onClose}
          title="Kiwi.com - Android app"
          store={`${translate(
            "support.passenger-details.correct-details.common.free",
          )} - Google Play`}
          onClick={this.trackAndroid}
          link="https://app.appsflyer.com/com.skypicker.main?pid=Kiwi_web&c=Smartbanner_Android"
        />
      )
    }
    // disabled for now, native promotion is currently being used
    if (this.props.showMobileAd && isiOS && false) {
      return (
        <MobileAdComponent
          onClose={this.onClose}
          title="Kiwi.com - iOS app"
          store={`${translate(
            "support.passenger-details.correct-details.common.free",
          )} - App Store`}
          onClick={this.trackiOS}
          link={`${
            isIphone
              ? "https://kiwi.onelink.me/1697797775?pid=kiwicomWebBanner&c=iPhone&af_dp=https%3A%2F%2Fwww.kiwi.com&af_web_dp=https%3A%2F%2Fitunes.apple.com%2Fapp%2Fkiwi-com-cheap-flight-tickets%2Fid657843853&is_retargeting=true"
              : "https://kiwi.onelink.me/1697797775" +
                "?pid=kiwicomWebBanner&c=webBannerIpad" +
                "&af_dp=kiwi%3A%2F%2FdeepLink&af_web_dp=https%3A%2F%2Fitunes.apple.com%2Fus%2Fapp%2Fid657843853%3Fmt%3D8"
          }`}
        />
      )
    }
    return null
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    showMobileAd: state.options.get("showMobileAd"),
  }),
  {
    setOption,
  },
)(MobileAd)
